import Swiper from 'swiper';
import {Pagination} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// init card slider
const initNews = () => {

    new Swiper(".ks-news .ks-news-swiper", {
        modules: [Pagination],
        speed: 1000,
        loop: false,
        autoHeight: false,
        slidesPerView: 1.5,
        centeredSlides: false,
        watchOverflow: true,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet opacity-100',
            bulletActiveClass: 'bg-cta'
        },
        breakpoints: {
            576: {
                slidesPerView: 1.5
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1400: {
                slidesPerView: 4,
            }
        }
    });

};

export default initNews;
